var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isMobile ? 'mobile' : 'pc'],attrs:{"id":"app"}},[_c('div',{ref:"layout",staticClass:"theme-d components-layout"},[_c('headerVue',{key:'hd' + _vm.componentKey}),_c('router-view',{on:{"refresh":_vm.handleRefresh}}),_c('footerVue',{key:'ft' + _vm.componentKey})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }